<template>
  <div>
    <navHeader></navHeader>
    <h2 class="main-title text-center mt-5">Market Calendar</h2>
   
    <div class="container mt-5">

         <p class="text-muted text-right"> Latest Update: {{ dateUpdated}}</p>

      <b-skeleton-img no-aspect height="600px" v-if="loading == true"></b-skeleton-img>
      <vc-calendar
        class="custom-calendar max-w-full mb-0"
        :masks="masks"
        :attributes="attributes"
        disable-page-swipe
        is-expanded
      >
    
        <template v-slot:day-content="{ day, attributes }">
          <div class="flex flex-col h-full z-10 overflow-hidden">
              <div class="current-day" v-if="day.isToday == true">
                <span class="day-label text-sm text--900">{{ day.day }}</span>
              </div>
            <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
            <div class="flex-grow overflow-y-auto overflow-x-auto">
              <p
                v-for="attr in attributes"
                :key="attr.key"
                class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
                :class="attr.customData.class"
              >
                {{ attr.customData.title }}
              </p>
            </div>
          </div>
        </template>
      </vc-calendar>
 <h4 class="main-title mt-5">Legend</h4>
      <div class="row mb-5">
        <div class="col-lg-6 col-md-6 col-12">
          <ul style="list-style-type: circle">
                      <li>AB - Analyst Briefing</li>
            <li>ASM - Annual Stockholders Meeting</li>
            <li>LD - Listing Date</li>
            <li>CD - Cash Dividend (Ex-Date)</li>
            <li>SD - Stock Dividend (Ex-Date)</li>
            <li>SRD: Stock Rights Offering (Ex-date)</li>
            <li>CHN - China</li>
          </ul>
        </div>
            <div class="col-lg-6 col-md-6 col-12">
             <ul style="list-style-type: circle">
            <li>US - United States of America</li>
            <li>PH - Philippines</li>
            <li>JP - Japan</li>
            <li>PMI - Purchasing Managers Index</li>
            <li>NFP - Non-Farm Payroll</li>
            <li>UR - Unemployment Rate</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { mapGetters, mapState } from "vuex";
import navHeader from "../../ResearchPages/NavHeader";
export default {
  components: {
    navHeader,
  },

  data() {
    return {
      masks: {
        weekdays: "WWW",
      },
      showCalendar: false,
      loading: false,
    };
  },
  methods: {
     GoogleAnalytics() {
      this.$gtag.event("MarketCalendar", { method: "Google" });
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "-------";
      } else {
        result = moment(date).format("LLL");
      }
      return result;
    },
    async GetMarketCalendarEvents() {
      var _this = this;
      this.loading = true;
      let dailyNotes = await this.$store
        .dispatch("philstocksResearch/GetMarketCalendarEvents")
        .catch(function (error) {
          console.log(error);
          _this.loading = false;
        });
      if (dailyNotes) {
        _this.loading = true;
      }
      _this.loading = false;
    },
  },

  computed: {
    ...mapGetters({
      attributes: "philstocksResearch/attributes",
    }),

     ...mapState({
      dateUpdated: (state) => state.philstocksResearch.dateUpdated,
    }),

  },

  async mounted() {
    this.GetMarketCalendarEvents();
  },
};
</script>
